// extracted by mini-css-extract-plugin
module.exports = {"cover":"hero-module--cover--2SOUz","button":"hero-module--button--3xlMv"};